import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";

import { Text } from "src/library/components/Text";
import {
  DateTemplatesType,
  Datetime
} from "src/library/components/Datetime";

/**
 * This function returns a reusable formated column definition for date data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for date data
 */
export const dateColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
  column: Partial<Pick<DisplayColumnDef<TData>, "header" | "id" | "enableSorting" | "enableColumnFilter">> & { format?: string; template?: DateTemplatesType; ignoreLocal?: boolean; }
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: column.id ? column.id : accessor,
    header: column.header ? column.header.toString() : typeof accessor === "string" ? accessor : "",
    cell: info => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const value = info.getValue() as any;

      if (value) {
        return (
          <Text>
            <Datetime
              ignoreLocal={column.ignoreLocal}
              format={column.format}
              template={column.template}
              date={value}
            />
          </Text>
        );
      }

      return null;
    },
    enableSorting: column.enableSorting,
    enableColumnFilter: column.enableColumnFilter,
    minSize: 70,
    meta: {
      style: { align: "left" },
      filter: { filterType: "dateRange" }
    }
  } as DisplayColumnDef<TData>);
};
